import type { BooleanFlag } from './baseTypes';

export enum SocketMessageType {
  task = 0,
  system = 1,
  like = 2,
  comment = 3,
}

export enum SocketTaskMessageType {
  pano = 1, // 素材制作
  product = 2, // 作品制作
  video = 3, // 视频制作
  reupload = 4, // 素材替换
  matrix = 5, // 矩阵素材
  matrixProduct = 6, // 矩阵作品
  matrixReupload = 7, // 矩阵替换
  market = 8, // 市场作品
}

export interface SocketTaskMessage {
  type: SocketTaskMessageType;
  id: number;
  success: BooleanFlag;
  name: string;
  message?: string;
}

export interface SocketMessage {
  type: SocketMessageType;
  content?: SocketTaskMessage;
}
